import { css } from 'styled-components';

export default css`
  .ant-btn.ant-btn-sm.ant-dropdown-trigger {
    width: 25px;
  }
`;
